import { render, staticRenderFns } from "./PowerRecord.vue?vue&type=template&id=1139c760&scoped=true&"
import script from "./PowerRecord.vue?vue&type=script&lang=js&"
export * from "./PowerRecord.vue?vue&type=script&lang=js&"
import style0 from "./PowerRecord.vue?vue&type=style&index=0&id=1139c760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1139c760",
  null
  
)

export default component.exports